const axios_request = require ("./axios_request.js")
const getregister= (R_data) =>{
          let url = '/hospitalconf/index/getdictionaries'
         axios_request.request_data("nodeserver", url, "post", null,(data)=>{
             console.log(data.data)
             return R_data = data
         });
      }



module.exports = {
    getregister,
}